module.exports = __webpack_public_path__ + "media/08_ASANBUDAPEST-Atmosphere08.9376daf0.mp3";